import { formatCurrency } from '@if/core/utils'
import { Caption, DisplayValue, OverlineCardHeader } from '@if/mui'
import { Card, CardContent, Stack } from '@mui/material'
import { formatComputed } from '@src/data/worksheet-selectors'
import { CalculatorEstimateResultDto } from '@src/types/CalculatorEstimateDto'
import { useTranslation } from 'react-i18next'

interface PaymentEstimateCardProps {
  calculatedRate?: CalculatorEstimateResultDto | null
  isFetching: boolean
  isAmountOutOfRange: boolean
}

/**
 * The live monthly-payment estimate. Uses the same summary-card shape as the
 * Custom Buydown PlanSummaryCard (Card → OverlineCardHeader → CardContent with the
 * design-system value/typography roles) so every summary card reads uniformly.
 */
export const PaymentEstimateCard = ({ calculatedRate, isFetching, isAmountOutOfRange }: PaymentEstimateCardProps) => {
  const { t } = useTranslation()

  return (
    <Card>
      <OverlineCardHeader title={t('calculator.monthlyPaymentEstimate')} />
      <CardContent>
        <Stack spacing={1}>
          <DisplayValue>
            {isFetching
              ? t('calculator.calculating')
              : formatComputed(isAmountOutOfRange ? null : (calculatedRate?.paymentForFrequency ?? 0), formatCurrency)}
          </DisplayValue>
          <Caption>{t('calculator.bestWayToKnow')}</Caption>
        </Stack>
      </CardContent>
    </Card>
  )
}
